import React, { useState } from "react";
import { BiSearchAlt } from "react-icons/bi";
import { TiArrowUnsorted } from "react-icons/ti";

export default function CaseLawSearchBox({
  placeholder,
  query,
  onSearch,
  courtType,
  limit,
  setLimit,
}) {
  const [keyword, setKeyword] = useState("keyword");
  const [searchQuery, setSearchQuery] = useState(query);

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
  };
  const handleSearchType = (e) => {
    const newKeyword = e.target.value;
    setKeyword(newKeyword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch && searchQuery) {
      onSearch(searchQuery, keyword, courtType);
    }
  };

  return (
    <>
      <div className="search-container">
        <div>
          <div className="search-select-container">
            <select value={limit} onChange={handleLimitChange}>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            <TiArrowUnsorted
              className="search-custom-arrow"
              size={18}
              color="#a6a8aa"
            />
          </div>
          <span className="search-select-text">records per page</span>
        </div>

        <div
          className="search-select-container search-dropdown"
          style={{ width: "12%" }}
        >
          <select value={keyword} onChange={handleSearchType}>
            <option value="keyword">Keyword</option>
            <option value="caseTitle">Case Title</option>
            <option value="caseNo">Case No</option>
            <option value="court">Court</option>
            <option value="location">Court Location</option>
            <option value="tags">Subject Matter</option>
          </select>
          <TiArrowUnsorted
            className="search-custom-arrow"
            size={18}
            color="#a6a8aa"
          />
        </div>

        <form className="search-box" onSubmit={handleSubmit}>
          <input
            type="text"
            name="search"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button>
            <BiSearchAlt size={16} style={{ transform: "scaleX(-1)" }} />
            Search
          </button>
        </form>
      </div>
    </>
  );
}
